<template>
  <div class="sub-activity-edit">
    <el-form ref="form" :model="form" :rules="rules" label-width="140px" size="small" :disabled="formLocked">

      <div class="section-title">基础信息</div>
      <div class="white-container">

        <el-form-item label="活动类型" prop="activityMode">
          <el-radio-group v-model="form.activityMode" :disabled="!!($route.query.id || $route.query.copyid)">
            <el-radio :label="0">常规赛</el-radio>
            <el-radio :label="1" :disabled="form.isLongTermActivity === 1">计时团队赛</el-radio>
            <el-radio :label="2" :disabled="form.isLongTermActivity === 1">计时个人赛</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="是否长期活动" prop="isLongTermActivity">
          <el-radio-group v-model="form.isLongTermActivity" :disabled="!!($route.query.id || $route.query.copyid || form.activityMode == 2 || form.activityMode == 1)">
            <el-radio :label="0">否</el-radio>
            <el-radio :label="1">是</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="是否在列表页展示" prop="isShow">
          <el-radio-group v-model="form.isShow">
            <el-radio :label="0">展示</el-radio>
            <el-radio :label="1">不展示</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="是否付费">
          <el-radio-group v-model="form.whetherToPay" disabled>
            <el-radio :label="0">否</el-radio>
            <el-radio :label="1">是</el-radio>
          </el-radio-group>
        </el-form-item>

        <!-- <el-form-item v-if="form.type === 1" label="报名人数" prop="participationNumber">
          <el-input v-model="form.participationNumber" style="width: 260px" placeholder="请输入报名人数" />
        </el-form-item> -->

        <div v-if="form.activityMode === 0 && form.type === 0" class="flex flex-wrap">
          <el-form-item label="团队男性人数" prop="maleLimit" :rules="{ required: true, message: '请输入男性人数', trigger: 'blur' }">
            <el-input v-model="form.maleLimit" style="width: 260px" placeholder="请输入男性人数" />
          </el-form-item>
          <el-form-item label="团队女性人数" prop="femaleLimit" :rules="{ required: true, message: '请输入女性人数', trigger: 'blur' }">
            <el-input v-model="form.femaleLimit" style="width: 260px" placeholder="请输入女性人数" />
          </el-form-item>
        </div>

        <el-form-item label="活动标题" prop="title">
          <el-input v-model="form.title" maxlength="23" style="width: 400px" placeholder="请输入活动标题，最多不超过23个字" />
        </el-form-item>

        <el-form-item label="活动日期" prop="_activityTime">
          <el-date-picker
            v-model="form._activityTime"
            type="datetimerange"
            value-format="yyyy.MM.dd HH:mm:ss"
            format="yyyy.MM.dd HH:mm:ss"
            range-separator="-"
            start-placeholder="开始日期和时间"
            end-placeholder="结束日期和时间"
            style="width: 400px"
          />
        </el-form-item>

        <template v-if="form.isLongTermActivity !== 1 && form.activityMode !== 1">
          <!-- 计时个人赛：活动场次 -->

          <!-- 常规赛：活动场次 -->
          <div v-if="form.activityMode !== 2">
            <div v-for="(item, index) in form.signUpTime" :key="'su_' + index" class="time-slot-row flex">
              <el-form-item label="场次时段" :prop="'signUpTime.' + index + '._time'" :rules="{ required: true, message: '请选择场次时段', trigger: 'change'}">
                <el-date-picker
                  v-model="item._time"
                  type="datetimerange"
                  value-format="yyyy.MM.dd HH:mm:ss"
                  format="yyyy.MM.dd HH:mm:ss"
                  range-separator="-"
                  start-placeholder="开始日期和时间"
                  end-placeholder="结束日期和时间"
                  style="width: 400px"
                />
              </el-form-item>
              <el-form-item :label="form.type === 0 ? '队伍数量' : '报名人数'" :prop="'signUpTime.' + index + '.applyNum'" label-width="100px" :rules="{ required: true, message: form.type === 0 ? '请输入队伍数量' : '请输入报名人数', trigger: 'blur'}">
                <el-input v-model="item.applyNum" style="width: 150px" :placeholder="form.type === 0 ? '队伍数量' : '报名人数'" />
              </el-form-item>
              <el-form-item v-if="form.type === 0" label="场次标识" :prop="'signUpTime.' + index + '.firstLetter'" label-width="100px" :rules="{ required: true, message: '请输入场次标识', trigger: 'blur'}">
                <el-input v-model="item.firstLetter" style="width: 150px" placeholder="请输入场次标识" />
              </el-form-item>
              <i class="el-icon-delete delete-icon" @click="removeLevel(index)" />
              <el-button v-if="index === form.signUpTime.length - 1" class="add-slot-btn" type="primary" style="margin-left: 20px;" @click="addLevel">添加时段</el-button>
            </div>
            <!-- 如果没有时段，显示添加按钮 -->
            <el-form-item v-if="form.signUpTime.length === 0" label="场次时段">
              <el-button class="add-slot-btn" type="primary" @click="addLevel">添加时段</el-button>
            </el-form-item>
          </div>
        </template>

        <template v-if="form.isLongTermActivity === 1 && form.activityMode !== 1">
          <div v-for="(item, index) in form.sessionTimeSlots" :key="'ss_' + index" class="time-slot-row flex session-slots-unlocked">
            <el-form-item label="场次时段" required>
              <el-time-picker v-model="item.beginTime" :disabled="false" value-format="HH:mm" format="HH:mm" placeholder="开始时间" style="width: 150px" :picker-options="{ selectableRange: '00:00:00 - 23:59:59' }" @change="(val) => onSessionBeginChange(val, index)" />
              <span style="margin: 0 5px;">-</span>
              <el-time-picker v-model="item.endTime" :disabled="false" value-format="HH:mm" format="HH:mm" placeholder="结束时间" style="width: 150px" :picker-options="item._endSelectableRange || {}" />
            </el-form-item>
            <el-form-item label="报名人数" :prop="'sessionTimeSlots.' + index + '.applyNum'" label-width="100px" :rules="{ required: true, message: '请输入报名人数', trigger: 'blur'}">
              <el-input v-model="item.applyNum" :disabled="false" style="width: 150px" placeholder="报名人数" />
            </el-form-item>
            <i class="el-icon-delete delete-icon" @click="removeSessionSlot(index)" />
            <el-button v-if="index === form.sessionTimeSlots.length - 1" :disabled="false" class="add-slot-btn" type="primary" style="margin-left: 20px;" @click="addSessionSlot">添加时段</el-button>
          </div>
          <el-form-item v-if="form.sessionTimeSlots.length === 0" label="场次时段" required>
            <el-button :disabled="false" class="add-slot-btn" type="primary" @click="addSessionSlot">添加时段</el-button>
          </el-form-item>
        </template>

        <div v-if="form.isLongTermActivity === 1 && form._activityTime && form._activityTime.length && form.sessionTimeSlots.length" style="margin-bottom: 22px; margin-left: 140px;">
          <el-button :disabled="false" type="text" class="link-color" @click="editCurrentMonthSpecial">{{ currentMonthBtnText }}</el-button>
          <el-button v-if="showNextMonthBtn || formLocked" :disabled="false" type="text" class="link-color" @click="editNextMonthSpecial">{{ nextMonthBtnText }}</el-button>
        </div>

        <el-form-item v-if="form.isLongTermActivity === 1 && (specialDateList.length || form.noDateSlots.length)" label="特殊日期">
          <div
            v-for="(item, index) in specialDateList"
            :key="'sd_' + index"
            class="special-date-tag"
          >
            <span class="special-date-link" @click="editExistingSpecialDate(item)">{{ item }}</span>
            <i v-if="!isDateLocked(item)" class="el-icon-delete delete-icon" @click="removeSpecialDateByDate(item)" />
          </div>
          <div
            v-for="(item, index) in form.noDateSlots"
            :key="'nd_' + index"
            class="special-date-tag no-date-tag"
          >
            <span class="special-date-link" @click="editExistingSpecialDate(item)">{{ item }}</span>
            <i v-if="!isDateLocked(item)" class="el-icon-delete delete-icon" @click="removeNoDateSlot(index)" />
          </div>
        </el-form-item>

        <el-form-item label="活动介绍" prop="content">
          <el-input v-model="form.content" type="textarea" :rows="4" style="width: 800px" />
        </el-form-item>

        <el-form-item label="注意事项" prop="announcement">
          <el-input v-model="form.announcement" type="textarea" :rows="4" style="width: 800px" />
        </el-form-item>

        <div class="flex addressrow">
          <el-form-item label="活动地址" prop="otherAddress">
            <el-input v-model="form.otherAddress" style="width: 300px" />
          </el-form-item>
          <el-button type="info" class="map-btn" @click="openMap">打开地图</el-button>
          <el-form-item label="坐标" prop="coordinate" class="coordinate-item">
            <el-input v-model="form.coordinate" placeholder="请输入纬度,经度" style="width: 300px" />
          </el-form-item>
        </div>

        <el-form-item label="报名开始时间" prop="registrationBeginTime">
          <el-date-picker v-model="form.registrationBeginTime" type="datetime" value-format="yyyy.MM.dd HH:mm:ss" format="yyyy.MM.dd HH:mm:ss" style="width: 260px" />
        </el-form-item>

        <el-form-item label="报名截止时间" prop="registrationEndTime">
          <el-date-picker v-model="form.registrationEndTime" type="datetime" value-format="yyyy.MM.dd HH:mm:ss" format="yyyy.MM.dd HH:mm:ss" style="width: 260px" />
        </el-form-item>
      </div>

      <div v-if="form.activityMode === 1" class="timing-team-groups">
        <div class="section-sub-title"> <span>*</span> 活动组别</div>
        <div v-for="(group, gIndex) in form.timingTeamGroups" :key="'tg_' + gIndex" class="timing-team-group">

          <div class="flex justify-between items-center item-title" style="width: 100%;">
            <div class="group-index">组别{{ gIndex + 1 }}</div>
            <i class="el-icon-delete delete-icon" @click="removeTimingTeamGroup(gIndex)" />
          </div>

          <div class="group-header flex flex-wrap">

            <el-form-item label="队伍人数" :prop="'timingTeamGroups.' + gIndex + '.teamSize'" :rules="{ required: true, message: '请输入队伍人数', trigger: 'blur' }">
              <el-input v-model="group.teamSize" style="width: 150px" placeholder="队伍人数" />
            </el-form-item>
            <el-form-item label="男子" :prop="'timingTeamGroups.' + gIndex + '.maleRequiredCount'" :rules="{ required: true, message: '请输入男子人数', trigger: 'blur' }">
              <el-input v-model="group.maleRequiredCount" style="width: 150px" placeholder="男子人数" />
            </el-form-item>
            <el-form-item label="女子" :prop="'timingTeamGroups.' + gIndex + '.femaleRequiredCount'" :rules="{ required: true, message: '请输入女子人数', trigger: 'blur' }">
              <el-input v-model="group.femaleRequiredCount" style="width: 150px" placeholder="女子人数" />
            </el-form-item>
            <!-- <i class="el-icon-delete delete-icon" @click="removeTimingTeamGroup(gIndex)" /> -->
          </div>

          <div>
            <el-form-item :label="'组别名称'" :prop="'timingTeamGroups.' + gIndex + '.groupName'" :rules="{ required: true, message: '请输入组别名称', trigger: 'blur' }">
              <el-input v-model="group.groupName" style="width: 150px" placeholder="请输入组别名称" />
            </el-form-item>
          </div>

          <div class="group-slots">
            <div v-for="(slot, sIndex) in group.slots" :key="'tgs_' + gIndex + '_' + sIndex" class="time-slot-row flex">
              <el-form-item label="活动日期" :prop="'timingTeamGroups.' + gIndex + '.slots.' + sIndex + '.activityDate'" :rules="{ required: true, message: '请选择活动日期', trigger: 'change' }">
                <el-date-picker v-model="slot.activityDate" type="date" value-format="yyyy-MM-dd" format="yyyy-MM-dd" placeholder="活动日期" style="width: 150px" />
              </el-form-item>
              <el-form-item label="场次时段" required>
                <el-time-picker v-model="slot.beginTime" value-format="HH:mm" format="HH:mm" placeholder="开始时间" style="width: 150px" :picker-options="{ selectableRange: '00:00:00 - 23:59:59' }" @change="(val) => onTimingTeamSlotBeginChange(val, gIndex, sIndex)" />
                <span style="margin: 0 5px;">-</span>
                <el-time-picker v-model="slot.endTime" value-format="HH:mm" format="HH:mm" placeholder="结束时间" style="width: 150px" :picker-options="slot._endSelectableRange || {}" />
              </el-form-item>
              <el-form-item label="队伍容量" :prop="'timingTeamGroups.' + gIndex + '.slots.' + sIndex + '.teamCapacity'" :rules="{ required: true, message: '请输入队伍容量', trigger: 'blur' }">
                <el-input v-model="slot.teamCapacity" style="width: 120px" placeholder="队伍容量" />
              </el-form-item>
              <i class="el-icon-delete delete-icon" @click="removeTimingTeamGroupSlot(gIndex, sIndex)" />
              <el-button v-if="sIndex === group.slots.length - 1" class="add-slot-btn" type="primary" style="margin-left: 20px;" @click="addTimingTeamGroupSlot(gIndex)">添加时段</el-button>
            </div>
            <el-form-item v-if="group.slots.length === 0" label="场次时段">
              <el-button class="add-slot-btn" type="primary" @click="addTimingTeamGroupSlot(gIndex)">添加时段</el-button>
            </el-form-item>
          </div>
        </div>

        <div class="add-box">
          <el-button class="add-slot-btn" type="primary" @click="addTimingTeamGroup"> +  添加组别</el-button>
        </div>
      </div>

      <div v-if="form.isLongTermActivity !== 1 && form.activityMode !== 1" class="timing-team-groups">
        <!-- 计时个人赛：活动场次 -->
        <div v-if="form.activityMode === 2" class="activity-sessions-section">
          <div class="section-sub-title"><span class="required-asterisk">*</span>活动场次</div>
          <div class="session-group-row">
            <el-form-item label="活动组别" prop="timingIndividualDivision" :rules="{ required: true, message: '请选择活动组别', trigger: 'change' }">
              <el-select v-model="form.timingIndividualDivision" placeholder="请选择" style="width: 200px">
                <el-option :value="1" label="大众组" />
                <el-option :value="2" label="精英组" />
              </el-select>
            </el-form-item>
          </div>
          <div v-for="(item, index) in form.signUpTime" :key="'su_' + index" class="time-slot-row flex">
            <el-form-item label="场次日期" :prop="'signUpTime.' + index + '.activityDate'" :rules="{ required: true, message: '请选择场次日期', trigger: 'change' }">
              <el-date-picker v-model="item.activityDate" type="date" value-format="yyyy-MM-dd" format="yyyy-MM-dd" placeholder="选择日期" style="width: 150px" />
            </el-form-item>
            <el-form-item label="场次时段" required>
              <el-time-picker v-model="item.beginTime" value-format="HH:mm" format="HH:mm" placeholder="开始时间" style="width: 120px" :picker-options="{ selectableRange: '00:00:00 - 23:59:59' }" @change="(val) => onSlotBeginChange(val, index)" />
              <span style="margin: 0 5px;">-</span>
              <el-time-picker v-model="item.endTime" value-format="HH:mm" format="HH:mm" placeholder="结束时间" style="width: 120px" :picker-options="item._endSelectableRange || {}" />
            </el-form-item>
            <el-form-item label="报名人数" :prop="'signUpTime.' + index + '.applyNum'" :rules="{ required: true, message: '请输入报名人数', trigger: 'blur' }">
              <el-input v-model="item.applyNum" style="width: 120px" placeholder="报名人数" />
            </el-form-item>
            <i class="el-icon-delete delete-icon" @click="removeLevel(index)" />
            <el-button v-if="index === form.signUpTime.length - 1" class="add-slot-btn" type="primary" style="margin-left: 20px;" @click="addLevel">添加时段</el-button>
          </div>
          <el-form-item v-if="form.signUpTime.length === 0" label="场次时段">
            <el-button class="add-slot-btn" type="primary" @click="addLevel">添加时段</el-button>
          </el-form-item>
        </div>
      </div>

      <div class="section-title" style="margin-top: 40px;">上传图片</div>
      <div class="white-container marginTop">
        <div class="upload-images-row">
          <el-form-item prop="headImg" label-width="0">
            <UploadImage :url="form.headImg" save-path="nextCombine/subActivity/" title="活动主图" size-tips="1125px*1125px" :limit-size="5" :show-replace="false" @upload="(url) => uploader('headImg', url)" />
          </el-form-item>
          <el-form-item prop="activityListImg" label-width="0">
            <UploadImage :url="form.activityListImg" save-path="nextCombine/subActivity/" title="活动列表图" size-tips="360px*576px" :limit-size="5" :show-replace="false" @upload="(url) => uploader('activityListImg', url)" />
          </el-form-item>
          <el-form-item prop="shareImage" label-width="0">
            <UploadImage :url="form.shareImage" save-path="nextCombine/subActivity/" title="活动分享海报" size-tips="849px*849px" :limit-size="5" :show-replace="false" @upload="(url) => uploader('shareImage', url)" />
          </el-form-item>
          <el-form-item prop="shareCardImage" label-width="0">
            <UploadImage :url="form.shareCardImage" save-path="nextCombine/subActivity/" title="活动分享卡片" size-tips="500px*400px" :limit-size="5" :show-replace="false" @upload="(url) => uploader('shareCardImage', url)" />
          </el-form-item>
        </div>
      </div>

      <div class="white-container marginTop">
        <el-form-item>
          <div class="flex btns">
            <el-button :disabled="false" type="info" @click="cancelBtn">取消</el-button>
            <el-button :disabled="false" type="primary" @click="submit">保存</el-button>
          </div>
        </el-form-item>
      </div>
    </el-form>
    <Dialog v-if="formDialogShow" v-model="formDialogShow" :information="information" @submit-success="dialogSuccess" />

    <el-dialog
      :visible.sync="currentMonthDialogVisible"
      width="1439px"
      top="0"
      :show-close="false"
      custom-class="special-date-dialog"
      @close="currentMonthDialogVisible = false"
    >
      <template slot="title">
        <div class="dialog-header">
          <span class="dialog-title">{{ specialDateDateDisabled ? '特殊日期' : (specialDateEditMode === 'next' ? '编辑次月特殊日期' : '编辑当月特殊日期') }}</span>
          <i class="el-icon-close dialog-close" @click="currentMonthDialogVisible = false" />
        </div>
      </template>
      <div class="dialog-content">
        <el-form :model="specialDateForm" label-width="100px" size="small">
          <el-form-item label="选择日期" required>
            <el-date-picker
              v-model="specialDateForm.date"
              type="date"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
              placeholder="请选择日期"
              style="width: 260px"
              :picker-options="specialDateDateOptions"
              :disabled="specialDateDateDisabled"
            />
          </el-form-item>

          <div class="dialog-scroll-area">
            <div v-for="(item, index) in specialDateForm.timeSlots" :key="'sds_' + index" class="time-slot-row flex">
              <el-form-item label="场次时段" required>
                <el-time-picker v-model="item.beginTime" value-format="HH:mm" format="HH:mm" placeholder="开始时间" style="width: 150px" :picker-options="{ selectableRange: '00:00:00 - 23:59:59' }" @change="(val) => onSpecialDateBeginChange(val, index)" />
                <span style="margin: 0 5px;">-</span>
                <el-time-picker v-model="item.endTime" value-format="HH:mm" format="HH:mm" placeholder="结束时间" style="width: 150px" :picker-options="item._endSelectableRange || {}" />
              </el-form-item>
              <el-form-item label="报名人数" :prop="'timeSlots.' + index + '.applyNum'" label-width="100px" :rules="{ required: true, message: '请输入报名人数', trigger: 'blur'}">
                <el-input v-model="item.applyNum" style="width: 120px" placeholder="报名人数" />
              </el-form-item>
              <el-form-item label="是否特邀场次" :prop="'timeSlots.' + index + '.isInvited'" label-width="120px" :rules="{ required: true, message: '请选择是否特邀场次', trigger: 'change'}">
                <el-select v-model="item.isInvited" :disabled="specialDatePreview" style="width: 100px" placeholder="请选择">
                  <el-option :value="false" label="否" />
                  <el-option :value="true" label="是" />
                </el-select>
              </el-form-item>
              <el-form-item
                v-if="item.isInvited"
                label="请输入场次名称"
                :prop="'timeSlots.' + index + '.invitedName'"
                label-width="130px"
                :rules="{ required: true, message: '请输入场次名称', trigger: 'blur'}"
              >
                <el-input v-model="item.invitedName" :disabled="specialDatePreview" style="width: 230px" maxlength="15" placeholder="请输入场次名称最多不超过15个字" />
              </el-form-item>
              <i v-if="!specialDatePreview" class="el-icon-delete delete-icon" @click="removeSpecialDateSlot(index)" />
              <el-button v-if="!specialDatePreview && index === specialDateForm.timeSlots.length - 1" class="add-slot-btn" type="primary" style="margin-left: 20px;" @click="addSpecialDateSlot">添加时段</el-button>
            </div>

            <el-form-item v-if="!specialDatePreview && specialDateForm.timeSlots.length === 0" label="场次时段">
              <el-button class="add-slot-btn" type="primary" @click="addSpecialDateSlot">添加时段</el-button>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div v-if="!specialDatePreview" class="special-date-btns">
        <el-button @click="currentMonthDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="saveSpecialDate">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import UploadImage from '@/components/UploadImage';
import Dialog from '@/components/Dialog';
import { getSubActivityDetail, addSubActivity, editSubActivity } from '@/api/combine';

export default {
  components: { UploadImage, Dialog },
  data() {
    return {
      formDialogShow: false,
      currentMonthDialogVisible: false,
      specialDateForm: {
        date: '',
        timeSlots: [],
      },
      specialDateEditMode: '',
      specialDateDateOptions: {},
      specialDateDateDisabled: false,
      specialDatePreview: false,
      isLoadingDetail: false,
      information: {},
      cancelTxt: '',
      form: {
        isLongTermActivity: 0,
        activityMode: 0, // 0-常规赛 1-计时团队赛 2-计时个人赛
        type: 1, // 1 for 个人赛, 0 for 团队赛；常规赛默认为1（后端会处理）
        timingIndividualDivision: 1, // 1-大众组 2-精英组
        timingTeamGroups: [],
        isShow: 0,
        whetherToPay: 0,
        participationNumber: 0,
        maleLimit: '',
        femaleLimit: '',
        title: '',
        _activityTime: [], // [开始日期, 结束日期]
        signUpTime: [
          { activityDate: "",
            beginTime: "",
            endTime: "",
            firstLetter: "",
            applyNum: '',
            surplusApplyNum: '',
            _time: [],
          },
        ],
        content: '',
        specialDateSlots: [],
        sessionTimeSlots: [],
        announcement: '',
        otherAddress: '',
        coordinate: '',
        registrationBeginTime: '',
        registrationEndTime: '',
        headImg: '',
        activityListImg: '',
        shareImage: '',
        shareCardImage: '',
        status: 1,
        nextMonthGenerationDay: 0,
        currentMonthConfirmed: false,
        nextMonthConfirmed: false,
        noDateSlots: [],
      },
      rules: {
        isLongTermActivity: [{ required: true, message: '请选择是否长期活动', trigger: 'change' }],
        activityMode: [{ required: true, message: '请选择赛事类型', trigger: 'change' }],
        // type: [{ required: true, message: '请选择活动类型', trigger: 'change' }],
        isShow: [{ required: true, message: '请选择是否在列表页展示', trigger: 'change' }],
        // participationNumber: [{ required: true, message: '请输入报名人数', trigger: 'blur' }],
        title: [{ required: true, message: '请输入活动标题', trigger: 'blur' }],
        _activityTime: [{ type: 'array', required: true, message: '请选择活动日期', trigger: 'change' }],
        content: [{ required: true, message: '请输入活动介绍', trigger: 'blur' }],
        announcement: [{ required: true, message: '请输入注意事项', trigger: 'blur' }],
        otherAddress: [{ required: true, message: '请输入活动地址', trigger: 'blur' }],
        coordinate: [{ required: true, message: '请输入坐标', trigger: 'blur' }],
        registrationBeginTime: [{ required: true, message: '请选择报名时间', trigger: 'change' }],
        registrationEndTime: [{ required: true, message: '请选择报名截止时间', trigger: 'change' }],
        headImg: [{ required: true, message: '请上传活动主图', trigger: 'change' }],
        activityListImg: [{ required: true, message: '请上传活动列表图', trigger: 'change' }],
        shareImage: [{ required: true, message: '请上传活动分享海报', trigger: 'change' }],
        shareCardImage: [{ required: true, message: '请上传活动分享卡片', trigger: 'change' }],
      },
    };
  },
  computed: {
    isEditMode() {
      return !!this.$route.query.id;
    },
    isAddOrCopy() {
      return !this.$route.query.id || !!this.$route.query.copyid;
    },
    isDraft() {
      return this.form.status === 1;
    },
    isPublished() {
      return this.form.status !== 1;
    },
    currentMonthBtnText() {
      return this.isPublished ? '查看当月场次' : '编辑当月特殊日期';
    },
    showNextMonthBtn() {
      if (this.isAddOrCopy) return false;
      if (this.isDraft) {
        return this.checkNextMonthGenerationDay();
      }
      return true;
    },
    nextMonthBtnText() {
      return this.isPublished && this.form.nextMonthConfirmed ? '查看次月场次' : '编辑次月特殊日期';
    },
    specialDateList() {
      const dates = [...new Set(this.form.specialDateSlots.map(item => item.date))];
      return dates;
    },
    formLocked() {
      return this.isEditMode && (this.form.status === 2 || this.form.status === 3);
    },
  },
  watch: {
    'form.isLongTermActivity'(val) {
      if (val === 1) {
        this.form.type = 1;
      }
    },
    'form.activityMode'(val) {
      if (val === 1) {
        this.form.type = 0;
      } else if (val === 2) {
        this.form.type = 1;
      }
    },
    'form._activityTime'() {
      if (!this.isLoadingDetail) {
        this.form.specialDateSlots = [];
      }
    },
    'specialDateForm.date'(newVal) {
      if (newVal && this.currentMonthDialogVisible) {
        this.loadSpecialDateForm(newVal);
      }
    },
  },
  mounted() {
    const { query } = this.$route;
    if (query.id) {
      console.info('编辑');
      this.cancelTxt = '编辑';
      this.getDetail(query.id, 'edit');
    } else if (query.copyid) {
      console.info('复制');
      this.cancelTxt = '复制';
      this.getDetail(query.copyid, 'copy');
    } else {
      console.info('新增');
      this.cancelTxt = '新增';
    }
  },
  methods: {
    checkNextMonthGenerationDay() {
      const day = this.form.nextMonthGenerationDay;
      if (!day) return false;
      const now = new Date();
      return now.getDate() >= day;
    },
    getReferenceMonth() {
      const today = new Date();
      const activityStart = this.form._activityTime && this.form._activityTime[0]
        ? new Date(this.form._activityTime[0].replace(/\./g, '-'))
        : today;
      return today >= activityStart ? today : activityStart;
    },
    isDateLocked(dateStr) {
      if (!this.isPublished) return false;
      const ref = this.getReferenceMonth();
      const refYear = ref.getFullYear();
      const refMonth = ref.getMonth();
      const date = new Date(dateStr.replace(/-/g, '/'));

      const refMonthEnd = new Date(refYear, refMonth + 1, 0);
      if (date <= refMonthEnd) return true;

      if (this.form.nextMonthConfirmed) {
        const nextMonthEnd = new Date(refYear, refMonth + 2, 0);
        if (date <= nextMonthEnd) return true;
      }
      return false;
    },
    editCurrentMonthSpecial() {
      this.specialDateEditMode = 'current';
      this.specialDateDateDisabled = false;
      this.specialDatePreview = this.isPublished;
      const activityStart = this.form._activityTime && this.form._activityTime[0]
        ? new Date(this.form._activityTime[0].replace(/\./g, '-'))
        : new Date();
      const startOfMonth = new Date(activityStart.getFullYear(), activityStart.getMonth(), activityStart.getDate());
      const endOfMonth = new Date(activityStart.getFullYear(), activityStart.getMonth() + 1, 0);
      const defaultDateStr = this.formatDate(activityStart);

      this.specialDateDateOptions = {
        disabledDate: (time) => {
          const t = new Date(time.getFullYear(), time.getMonth(), time.getDate());
          return t < startOfMonth || t > endOfMonth;
        },
      };

      this.loadSpecialDateForm(defaultDateStr);
      this.currentMonthDialogVisible = true;
    },
    editExistingSpecialDate(dateStr) {
      this.specialDateEditMode = 'current';
      this.specialDateDateDisabled = true;
      this.specialDatePreview = this.isDateLocked(dateStr);
      this.specialDateDateOptions = {};
      this.loadSpecialDateForm(dateStr);
      this.currentMonthDialogVisible = true;
    },
    editNextMonthSpecial() {
      this.specialDateEditMode = 'next';
      this.specialDateDateDisabled = false;
      this.specialDatePreview = this.isPublished && this.form.nextMonthConfirmed;
      const ref = this.getReferenceMonth();
      const nextMonthStart = new Date(ref.getFullYear(), ref.getMonth() + 1, 1);
      const nextMonthEnd = new Date(ref.getFullYear(), ref.getMonth() + 2, 0);
      const defaultDate = this.formatDate(nextMonthStart);

      this.specialDateDateOptions = {
        disabledDate: (time) => {
          const t = new Date(time.getFullYear(), time.getMonth(), time.getDate());
          return t < nextMonthStart || t > nextMonthEnd;
        },
      };
      this.loadSpecialDateForm(defaultDate);
      this.currentMonthDialogVisible = true;
    },
    formatDate(date) {
      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, '0');
      const d = String(date.getDate()).padStart(2, '0');
      return `${y}-${m}-${d}`;
    },
    loadSpecialDateForm(dateStr) {
      if (this.form.noDateSlots.includes(dateStr)) {
        this.specialDateForm.timeSlots = [];
        this.specialDateForm.date = dateStr;
        return;
      }
      const existing = this.form.specialDateSlots.filter(item => item.date === dateStr);
      if (existing.length > 0) {
        this.specialDateForm.timeSlots = existing.map(item => ({
          beginTime: item.beginTime,
          endTime: item.endTime,
          applyNum: item.applyNum,
          isInvited: !!item.isInvited,
          invitedName: item.invitedName || '',
          _endSelectableRange: item.beginTime ? { selectableRange: `${item.beginTime}:00 - 23:59:59` } : {},
        }));
      } else {
        this.specialDateForm.timeSlots = this.form.sessionTimeSlots.map(item => ({
          beginTime: item.beginTime,
          endTime: item.endTime,
          applyNum: item.applyNum,
          isInvited: false,
          invitedName: '',
          _endSelectableRange: item.beginTime ? { selectableRange: `${item.beginTime}:00 - 23:59:59` } : {},
        }));
      }
      this.specialDateForm.date = dateStr;
    },
    addSpecialDateSlot() {
      this.specialDateForm.timeSlots.push({ beginTime: '', endTime: '', applyNum: '', isInvited: false, invitedName: '', _endSelectableRange: {} });
    },
    removeSpecialDateSlot(index) {
      this.specialDateForm.timeSlots.splice(index, 1);
    },
    onSpecialDateBeginChange(val, index) {
      const item = this.specialDateForm.timeSlots[index];
      if (val) {
        item._endSelectableRange = { selectableRange: `${val}:00 - 23:59:59` };
        if (item.endTime && item.endTime <= val) {
          item.endTime = '';
        }
      } else {
        item._endSelectableRange = {};
      }
    },
    saveSpecialDate() {
      if (!this.specialDateForm.date) {
        this.$message.warning('请选择日期');
        return;
      }
      const date = this.specialDateForm.date;
      if (this.specialDateForm.timeSlots.length === 0) {
        if (!this.form.noDateSlots.includes(date)) {
          this.form.noDateSlots.push(date);
        }
        this.form.specialDateSlots = this.form.specialDateSlots.filter(item => item.date !== date);
        this.currentMonthDialogVisible = false;
        return;
      }
      for (let i = 0; i < this.specialDateForm.timeSlots.length; i++) {
        const slot = this.specialDateForm.timeSlots[i];
        if (!slot.beginTime) {
          this.$message.warning(`场次时段${i + 1}请选择开始时间`);
          return;
        }
        if (!slot.endTime) {
          this.$message.warning(`场次时段${i + 1}请选择结束时间`);
          return;
        }
        if (!slot.applyNum) {
          this.$message.warning(`场次时段${i + 1}请输入报名人数`);
          return;
        }
        if (slot.isInvited && !slot.invitedName) {
          this.$message.warning(`场次时段${i + 1}请输入场次名称`);
          return;
        }
      }
      this.form.noDateSlots = this.form.noDateSlots.filter(d => d !== date);
      const newSlots = this.form.specialDateSlots.filter(
        item => item.date !== date
      );
      for (const slot of this.specialDateForm.timeSlots) {
        newSlots.push({
          date,
          beginTime: slot.beginTime,
          endTime: slot.endTime,
          applyNum: Number(slot.applyNum) || 0,
          isInvited: !!slot.isInvited,
          invitedName: slot.isInvited ? (slot.invitedName || '') : '',
        });
      }
      this.form.specialDateSlots = newSlots;
      this.currentMonthDialogVisible = false;
    },
    addLevel() {
      this.form.signUpTime.push({
        activityDate: '',
        beginTime: '',
        endTime: '',
        firstLetter: '',
        applyNum: '',
        surplusApplyNum: '',
        _time: [],
        _endSelectableRange: {},
      });
    },
    removeLevel(index) {
      this.form.signUpTime.splice(index, 1);
    },
    removeSpecialDate(index) {
      this.form.specialDateSlots.splice(index, 1);
    },
    removeSpecialDateByDate(date) {
      this.form.specialDateSlots = this.form.specialDateSlots.filter(item => item.date !== date);
    },
    removeNoDateSlot(index) {
      this.form.noDateSlots.splice(index, 1);
    },
    addSessionSlot() {
      this.form.sessionTimeSlots.push({ beginTime: '', endTime: '', applyNum: '', _endSelectableRange: {} });
    },
    removeSessionSlot(index) {
      this.form.sessionTimeSlots.splice(index, 1);
    },
    addTimingTeamGroup() {
      this.form.timingTeamGroups.push({
        groupName: '',
        teamSize: '',
        maleRequiredCount: '',
        femaleRequiredCount: '',
        slots: [],
      });
    },
    removeTimingTeamGroup(index) {
      this.form.timingTeamGroups.splice(index, 1);
    },
    addTimingTeamGroupSlot(groupIndex) {
      this.form.timingTeamGroups[groupIndex].slots.push({
        activityDate: '',
        beginTime: '',
        endTime: '',
        teamCapacity: '',
        _endSelectableRange: {},
      });
    },
    removeTimingTeamGroupSlot(groupIndex, slotIndex) {
      this.form.timingTeamGroups[groupIndex].slots.splice(slotIndex, 1);
    },
    onTimingTeamSlotBeginChange(val, groupIndex, slotIndex) {
      const slot = this.form.timingTeamGroups[groupIndex].slots[slotIndex];
      if (val) {
        slot._endSelectableRange = { selectableRange: `${val}:00 - 23:59:59` };
        if (slot.endTime && slot.endTime <= val) {
          slot.endTime = '';
        }
      } else {
        slot._endSelectableRange = {};
      }
    },
    onSlotBeginChange(val, index) {
      const item = this.form.signUpTime[index];
      if (val) {
        item._endSelectableRange = { selectableRange: `${val}:00 - 23:59:59` };
        if (item.endTime && item.endTime <= val) {
          item.endTime = '';
        }
      } else {
        item._endSelectableRange = {};
      }
    },
    onSessionBeginChange(val, index) {
      const item = this.form.sessionTimeSlots[index];
      if (val) {
        item._endSelectableRange = { selectableRange: `${val}:00 - 23:59:59` };
        if (item.endTime && item.endTime <= val) {
          item.endTime = '';
        }
      } else {
        item._endSelectableRange = {};
      }
    },
    openMap() {
      window.open('https://lbs.qq.com/getPoint/');
    },
    uploader(key, url) {
      this.form[key] = url;
    },
    parseTime(str) {
      if (!str) return null;
      return new Date(str.replace(/\./g, '-'));
    },
    parseDate(str) {
      if (!str) return null;
      const d = new Date(str.replace(/\./g, '-'));
      d.setHours(0, 0, 0, 0);
      return d;
    },
    validateTimes() {
      const isAdd = !this.$route.query.id;
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const activityStart = this.form._activityTime && this.form._activityTime[0]
        ? this.parseTime(this.form._activityTime[0]) : null;
      const activityEnd = this.form._activityTime && this.form._activityTime[1]
        ? this.parseTime(this.form._activityTime[1]) : null;
      const activityStartDate = this.form._activityTime && this.form._activityTime[0]
        ? this.parseDate(this.form._activityTime[0]) : null;
      const activityEndDate = this.form._activityTime && this.form._activityTime[1]
        ? this.parseDate(this.form._activityTime[1]) : null;
      const regStart = this.parseTime(this.form.registrationBeginTime);
      const regEnd = this.parseTime(this.form.registrationEndTime);

      // 新增模式：所有时间不能早于今天
      if (isAdd) {
        if (activityStart && activityStart < today) {
          this.$message.warning('活动开始时间不能早于今天');
          return false;
        }
        if (activityEnd && activityEnd < today) {
          this.$message.warning('活动结束时间不能早于今天');
          return false;
        }
        if (regStart && regStart < today) {
          this.$message.warning('报名开始时间不能早于今天');
          return false;
        }
        if (regEnd && regEnd < today) {
          this.$message.warning('报名截止时间不能早于今天');
          return false;
        }
        if (this.form.activityMode !== 1) {
          for (let i = 0; i < this.form.signUpTime.length; i++) {
            const slot = this.form.signUpTime[i];
            if (this.form.activityMode === 2) {
              if (slot.activityDate) {
                const slotDate = this.parseDate(slot.activityDate);
                if (slotDate && slotDate < today) {
                  this.$message.warning(`场次${i + 1}的活动日期不能早于今天`);
                  return false;
                }
              }
            } else if (slot._time && slot._time.length === 2) {
              const slotStart = this.parseTime(slot._time[0]);
              if (slotStart && slotStart < today) {
                this.$message.warning(`场次时段${i + 1}的开始时间不能早于今天`);
                return false;
              }
            }
          }
        }
        // 计时团队赛场次日期不能早于今天
        if (this.form.activityMode === 1) {
          for (let g = 0; g < this.form.timingTeamGroups.length; g++) {
            const group = this.form.timingTeamGroups[g];
            for (let s = 0; s < group.slots.length; s++) {
              const slot = group.slots[s];
              if (slot.activityDate) {
                const slotDate = this.parseDate(slot.activityDate);
                if (slotDate && slotDate < today) {
                  this.$message.warning(`组别${g + 1}场次${s + 1}的活动日期不能早于今天`);
                  return false;
                }
              }
            }
          }
        }
      }

      // 校验场次时间在活动范围内（仅非长期活动且非计时团队赛）
      if (this.form.isLongTermActivity !== 1 && this.form.activityMode !== 1) {
        for (let i = 0; i < this.form.signUpTime.length; i++) {
          const slot = this.form.signUpTime[i];
          if (this.form.activityMode === 2) {
            if (slot.activityDate) {
              const slotDate = this.parseDate(slot.activityDate);
              if (activityStartDate && slotDate && slotDate < activityStartDate) {
                this.$message.warning(`场次${i + 1}的活动日期不能早于活动开始日期`);
                return false;
              }
              if (activityEndDate && slotDate && slotDate > activityEndDate) {
                this.$message.warning(`场次${i + 1}的活动日期不能晚于活动结束日期`);
                return false;
              }
            }
            if (slot.beginTime && slot.endTime && slot.endTime <= slot.beginTime) {
              this.$message.warning(`场次${i + 1}的结束时间必须晚于开始时间`);
              return false;
            }
          } else if (slot._time && slot._time.length === 2) {
            const slotStart = this.parseTime(slot._time[0]);
            const slotEnd = this.parseTime(slot._time[1]);
            if (activityStart && slotStart && slotStart < activityStart) {
              this.$message.warning(`场次时段${i + 1}的开始时间不能早于活动开始时间`);
              return false;
            }
            if (activityEnd && slotEnd && slotEnd > activityEnd) {
              this.$message.warning(`场次时段${i + 1}的结束时间不能晚于活动结束时间`);
              return false;
            }
          }
        }
      }

      // 报名截止要在报名开始之后
      if (regStart && regEnd && regEnd <= regStart) {
        this.$message.warning('报名截止时间必须在报名开始时间之后');
        return false;
      }

      // 报名截止时间不晚于活动结束时间
      if (regEnd && activityEnd && regEnd > activityEnd) {
        this.$message.warning('报名截止时间不能晚于活动结束时间');
        return false;
      }

      // 长期活动：sessionTimeSlots 必填
      if (this.form.isLongTermActivity === 1 && this.form.activityMode !== 1 && this.form.sessionTimeSlots.length === 0) {
        this.$message.warning('请至少添加一个场次时段');
        return false;
      }

      // 长期活动：sessionTimeSlots 每项必填
      if (this.form.isLongTermActivity === 1 && this.form.activityMode !== 1) {
        for (let i = 0; i < this.form.sessionTimeSlots.length; i++) {
          const slot = this.form.sessionTimeSlots[i];
          if (!slot.beginTime) {
            this.$message.warning(`场次时段${i + 1}请选择开始时间`);
            return false;
          }
          if (!slot.endTime) {
            this.$message.warning(`场次时段${i + 1}请选择结束时间`);
            return false;
          }
          if (!slot.applyNum) {
            this.$message.warning(`场次时段${i + 1}请输入报名人数`);
            return false;
          }
        }
      }

      // 计时团队赛校验
      if (this.form.activityMode === 1) {
        if (this.form.timingTeamGroups.length === 0) {
          this.$message.warning('请至少添加一个活动组别');
          return false;
        }
        for (let g = 0; g < this.form.timingTeamGroups.length; g++) {
          const group = this.form.timingTeamGroups[g];
          if (!group.groupName) {
            this.$message.warning(`组别${g + 1}请输入组别名称`);
            return false;
          }
          if (!group.teamSize) {
            this.$message.warning(`组别${g + 1}请输入队伍总人数`);
            return false;
          }
          if (group.maleRequiredCount === undefined || group.maleRequiredCount === null || group.maleRequiredCount === '') {
            this.$message.warning(`组别${g + 1}请输入男性人数`);
            return false;
          }
          if (group.femaleRequiredCount === undefined || group.femaleRequiredCount === null || group.femaleRequiredCount === '') {
            this.$message.warning(`组别${g + 1}请输入女性人数`);
            return false;
          }
          if (!group.slots || group.slots.length === 0) {
            this.$message.warning(`组别${g + 1}请至少添加一个场次`);
            return false;
          }
          for (let s = 0; s < group.slots.length; s++) {
            const slot = group.slots[s];
            if (!slot.activityDate) {
              this.$message.warning(`组别${g + 1}场次${s + 1}请选择活动日期`);
              return false;
            }
            if (!slot.beginTime) {
              this.$message.warning(`组别${g + 1}场次${s + 1}请选择开始时间`);
              return false;
            }
            if (!slot.endTime) {
              this.$message.warning(`组别${g + 1}场次${s + 1}请选择结束时间`);
              return false;
            }
            if (!slot.teamCapacity) {
              this.$message.warning(`组别${g + 1}场次${s + 1}请输入队伍容量`);
              return false;
            }
            const slotDate = this.parseDate(slot.activityDate);
            if (activityStartDate && slotDate && slotDate < activityStartDate) {
              this.$message.warning(`组别${g + 1}场次${s + 1}的活动日期不能早于活动开始日期`);
              return false;
            }
            if (activityEndDate && slotDate && slotDate > activityEndDate) {
              this.$message.warning(`组别${g + 1}场次${s + 1}的活动日期不能晚于活动结束日期`);
              return false;
            }
          }
        }
      }

      return true;
    },
    submit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (!this.validateTimes()) return;
          this.formDialogShow = true;
          this.information = {
            operation: 'submit',
            icon: 'warn',
            subTitle: "将保存本次的新增/编辑操作",
          };
        } else {
          return false;
        }
      });
    },
    getDetail(id, type) {
      getSubActivityDetail(id).then(res => {
        this.isLoadingDetail = true;
        const _activityTime = res.beginTime && res.endTime
          ? [res.beginTime.replace(/-/g, '.'), res.endTime.replace(/-/g, '.')]
          : [];
        const signUpTime = (res.signUpTime || []).map(item => {
          const date = item.activityDate ? item.activityDate.replace(/-/g, '.') : '';
          const beginTime = item.beginTime ? item.beginTime.substring(0, 5) : '';
          const endTime = item.endTime ? item.endTime.substring(0, 5) : '';
          const start = date && item.beginTime ? `${date} ${item.beginTime}` : '';
          const end = date && item.endTime ? `${date} ${item.endTime}` : '';
          return {
            ...item,
            activityDate: item.activityDate || '',
            beginTime,
            endTime,
            _endSelectableRange: beginTime ? { selectableRange: `${beginTime}:00 - 23:59:59` } : {},
            _time: start && end ? [start, end] : [],
          };
        });
        const dot = v => v ? v.replace(/-/g, '.') : '';
        if (type === 'copy') {
          delete res.combineRelationId;
          res.timingTeamGroups = (res.timingTeamGroups || []).map(group => ({
            ...group,
            id: undefined,
            slots: (group.slots || []).map(slot => ({ ...slot, id: undefined })),
          }));
        }
        // 旧数据未返回 activityMode 时默认按常规赛处理
        const activityMode = res.activityMode === undefined || res.activityMode === null ? 0 : res.activityMode;
        // res.nextMonthConfirmed = true;
        this.form = Object.assign(this.form, res, {
          id: type === 'edit' ? id : undefined,
          _activityTime,
          activityMode,
          timingIndividualDivision: res.timingIndividualDivision || 1,
          timingTeamGroups: (res.timingTeamGroups || []).map(group => ({
            ...group,
            teamSize: group.teamSize !== undefined && group.teamSize !== null ? String(group.teamSize) : '',
            maleRequiredCount: group.maleRequiredCount !== undefined && group.maleRequiredCount !== null ? String(group.maleRequiredCount) : '',
            femaleRequiredCount: group.femaleRequiredCount !== undefined && group.femaleRequiredCount !== null ? String(group.femaleRequiredCount) : '',
            slots: (group.slots || []).map(slot => {
              const beginTime = slot.beginTime ? slot.beginTime.substring(0, 5) : '';
              const endTime = slot.endTime ? slot.endTime.substring(0, 5) : '';
              return {
                ...slot,
                beginTime,
                endTime,
                _endSelectableRange: beginTime ? { selectableRange: `${beginTime}:00 - 23:59:59` } : {},
              };
            }),
          })),
          signUpTime: res.isLongTermActivity === 1 ? [] : (signUpTime.length ? signUpTime : [{
            activityDate: '',
            beginTime: '',
            endTime: '',
            firstLetter: '',
            applyNum: '',
            surplusApplyNum: '',
            _time: [],
            _endSelectableRange: {},
          }]),
          sessionTimeSlots: (res.sessionTimeSlots || []).map(item => {
            const beginTime = item.beginTime ? item.beginTime.substring(0, 5) : '';
            const endTime = item.endTime ? item.endTime.substring(0, 5) : '';
            return {
              ...item,
              beginTime,
              endTime,
              _endSelectableRange: beginTime ? { selectableRange: `${beginTime}:00 - 23:59:59` } : {},
            };
          }),
          registrationBeginTime: dot(res.registrationBeginTime),
          registrationEndTime: dot(res.registrationEndTime),
          specialDateSlots: (res.specialDateSlots || []).map(item => ({
            ...item,
            beginTime: item.beginTime ? item.beginTime.substring(0, 5) : '',
            endTime: item.endTime ? item.endTime.substring(0, 5) : '',
          })),
        });
        this.$nextTick(() => {
          this.isLoadingDetail = false;
        });
      });
    },
    addEditItem() {
      const params = { ...this.form };
      // 活动日期
      if (params._activityTime && params._activityTime.length === 2) {
        params.beginTime = params._activityTime[0].replace(/\./g, '-');
        params.endTime = params._activityTime[1].replace(/\./g, '-');
      }
      delete params._activityTime;

      // 根据赛事类型清理/转换字段
      if (params.activityMode === 0) {
        // 常规赛
        delete params.timingIndividualDivision;
        delete params.timingTeamGroups;
      } else if (params.activityMode === 1) {
        // 计时团队赛
        delete params.timingIndividualDivision;
        delete params.signUpTime;
        delete params.sessionTimeSlots;
        delete params.specialDateSlots;
        delete params.noDateSlots;
        delete params.maleLimit;
        delete params.femaleLimit;
        params.timingTeamGroups = (params.timingTeamGroups || []).map(group => ({
          id: group.id,
          groupName: group.groupName,
          teamSize: Number(group.teamSize) || 0,
          maleRequiredCount: Number(group.maleRequiredCount) || 0,
          femaleRequiredCount: Number(group.femaleRequiredCount) || 0,
          slots: (group.slots || []).map(slot => ({
            id: slot.id,
            activityDate: slot.activityDate,
            beginTime: slot.beginTime ? `${slot.beginTime}:00` : '',
            endTime: slot.endTime ? `${slot.endTime}:00` : '',
            teamCapacity: Number(slot.teamCapacity) || 0,
          })),
        }));
      } else if (params.activityMode === 2) {
        // 计时个人赛
        delete params.timingTeamGroups;
        delete params.maleLimit;
        delete params.femaleLimit;
      }

      if (params.isLongTermActivity === 1) {
        // 长期活动：传 sessionTimeSlots，删除 signUpTime
        delete params.signUpTime;
        params.sessionTimeSlots = params.sessionTimeSlots.map(item => ({
          beginTime: item.beginTime ? `${item.beginTime}:00` : '',
          endTime: item.endTime ? `${item.endTime}:00` : '',
          applyNum: item.applyNum,
        }));
        if (params.participationNumber === 0 && params.sessionTimeSlots.length > 0) {
          params.participationNumber = params.sessionTimeSlots.reduce((acc, item) => acc + (Number(item.applyNum) || 0), 0);
        }
        params.specialDateSlots = (params.specialDateSlots || []).map(item => ({
          ...item,
          beginTime: item.beginTime ? `${item.beginTime}:00` : '',
          endTime: item.endTime ? `${item.endTime}:00` : '',
        }));
      } else {
        // 非长期活动：传 signUpTime，删除 sessionTimeSlots
        delete params.sessionTimeSlots;
        // 场次时段：拆分 activityDate、beginTime、endTime
        if (params.signUpTime) {
          params.signUpTime = params.signUpTime.map(item => {
            if (params.activityMode === 2) {
              const result = { ...item, activityDate: item.activityDate || '' };
              result.beginTime = item.beginTime ? `${item.beginTime}:00` : '';
              result.endTime = item.endTime ? `${item.endTime}:00` : '';
              delete result.firstLetter;
              delete result._time;
              delete result._endSelectableRange;
              return result;
            }
            let activityDate = ''; let beginT = ''; let endT = '';
            if (item._time && item._time.length === 2) {
              const start = item._time[0].replace(/\./g, '-');
              const end = item._time[1].replace(/\./g, '-');
              activityDate = start.split(' ')[0] || '';
              beginT = start.split(' ')[1] || '';
              endT = end.split(' ')[1] || '';
            }
            return { ...item, activityDate, beginTime: beginT, endTime: endT };
          });
        }
      }

      // 报名时间
      if (params.registrationBeginTime) {
        params.registrationBeginTime = params.registrationBeginTime.replace(/\./g, '-');
      }
      if (params.registrationEndTime) {
        params.registrationEndTime = params.registrationEndTime.replace(/\./g, '-');
      }

      // title → name
      params.name = params.title;
      delete params.title;

      // 平铺图片字段 → activityImageVO
      params.activityImageVO = {
        activityDetailsPageHeader: params.headImg,
        activityListPagePicture: params.activityListImg,
        shareImage: params.shareImage,
        shareCardImage: params.shareCardImage,
      };
      delete params.headImg;
      delete params.activityListImg;
      delete params.shareImage;
      delete params.shareCardImage;

      !params.id && delete params.id;
      !params.id && delete params.uaEventCityId;
      const api = params.id ? editSubActivity : addSubActivity;
      /* 计算participationNumber */
      if (params.signUpTime && params.signUpTime.length > 0) {
        params.participationNumber = params.signUpTime.reduce((acc, item) => acc + (Number(item.applyNum) || 0), 0);
      }
      api(params).then(() => {
        this.$message.success(params.id ? '编辑成功' : '保存成功');
        this.$router.go(-1);
      });
    },
    cancelBtn() {
      this.formDialogShow = true;
      this.information = {
        operation: 'cancel',
        icon: 'warn',
        subTitle: `是否放弃${this.cancelTxt}，返回上级页面？`,
      };
    },
    dialogSuccess() {
      if (this.information.operation && this.information.operation === 'cancel') {
        this.$router.go(-1);
      } else if (this.information.operation && this.information.operation === 'submit') {
        this.addEditItem();
      }
    },
  },
};
</script>

<style lang="less" scoped>
.sub-activity-edit {
  padding: 24px;
  background-color: #fafafa;
  min-height: calc(100vh - 84px);

  .section-title {
    font-size: 16px;
    font-weight: bold;
    color: #333;
    margin-bottom: 20px;
    padding-left: 10px;
  }

  .white-container {
    background: #fff;
    padding: 30px;
    border-radius: 4px;
    box-shadow: 0 1px 4px rgba(0,21,41,.08);
  }

  .flex {
    display: flex;
    align-items: center;
  }

  .flex-wrap {
    flex-wrap: wrap;
  }

  .time-slot-row {
    margin-bottom: 20px;

    ::v-deep .el-form-item {
      margin-bottom: 0;
    }

    &.session-slots-unlocked {
      pointer-events: auto;
      opacity: 1;

      ::v-deep .el-form-item.is-disabled {
        pointer-events: auto;
        opacity: 1;

        .el-input__inner,
        .el-textarea__inner,
        .el-time-panel,
        .el-button {
          pointer-events: auto;
          opacity: 1;
        }
      }

      ::v-deep .el-input.is-disabled .el-input__inner {
        background-color: #fff;
        color: #606266;
        cursor: pointer;
      }
    }
  }
  .delete-icon {
    font-size: 20px;
    color: #F56C6C;
    cursor: pointer;
    margin-left: 15px;
  }

  .add-box {
    text-align: center;
  }

  .add-slot-btn {
    background-color: #000;
    border-color: #000;
    color: #fff;
    &:hover {
      background-color: #333;
      border-color: #333;
    }
  }

  .activity-sessions-section {
    .section-sub-title {
      font-size: 14px;
      font-weight: bold;
      color: #333;
      margin-bottom: 16px;

      .required-asterisk {
        color: #F56C6C;
        margin-right: 4px;
      }
    }

    .session-group-row {
      margin-bottom: 16px;

      ::v-deep .el-form-item {
        margin-bottom: 0;
      }
    }

    .time-slot-row {
      align-items: center;

      ::v-deep .el-form-item {
        margin-bottom: 0;
        margin-right: 16px;
      }
    }
  }

  .timing-team-groups {
    background: #fff;
    padding: 30px;
    border-radius: 4px;
    box-shadow: 0 1px 4px rgba(0,21,41,.08);
    margin: 30px 0;
    .item-title{
      margin-bottom: 20px;
       justify-content:  space-between
    }

    .section-sub-title {
      font-size: 14px;
      font-weight: bold;
      color: #333;
      margin-bottom: 16px;
      span {
        color: #F56C6C;
        margin-right: 4px;
      }
    }

    .timing-team-group {
      background: #f7f8f9;
      padding: 20px;
      margin-bottom: 20px;
      border-radius: 4px;

      .group-header {
        margin-bottom: 16px;
        align-items: center;

        .el-form-item {
          margin-right: 20px;
          margin-bottom: 0;
        }
      }

      .group-slots {
        padding-left: 20px;
      }
    }
  }

  .addressrow {
    align-items: center;
    margin-bottom: 24px;
    .el-button {
      margin-left: 10px;
      flex-shrink: 0;
    }
    ::v-deep .el-form-item {
      margin-bottom: 0 !important;
    }
  }

  .coordinate-item {
    margin-left: 10px;
    ::v-deep .el-form-item__label {
      width: 60px !important;
    }
    ::v-deep .el-form-item__content {
      margin-left: 60px !important;
    }
  }

  .map-btn {
    background-color: #000;
    border-color: #000;
    color: #fff;
    &:hover {
      background-color: #333;
      border-color: #333;
    }
  }

  .marginTop {
    margin-top: 20px;
  }

  .upload-images-row {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    ::v-deep .uploader .tip {
      margin-top: 10px;
      &::before {
        content: '*';
        color: #F56C6C;
        margin-right: 2px;
      }
    }
  }

  .btns {
    justify-content: center;
    margin-top: 30px;
  }

  .special-date-tag {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    height: 41px;
    width: 160px;
    padding: 0 10px;
    margin-right: 10px;
    background: #f4f4f5;
    border: 1px solid #e9e9eb;
    border-radius: 4px;
    font-size: 14px;
    color: #909399;
    margin-bottom: 10px;
    .special-date-link {
      color: #000;
      text-decoration: underline;
      cursor: pointer;
    }

    &.no-date-tag {
      margin-bottom: 10px;
    }

    .delete-icon {
      font-size: 16px;
      color: #F56C6C;
      cursor: pointer;
    }
  }
}
</style>

<style lang="less">
.special-date-dialog {
  margin-top: calc(50vh - 302px) !important;
  border-radius: 0;

  .el-dialog__header {
    padding: 0;
  }

  .el-dialog__body {
    padding: 0;
  }

  .dialog-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 74px;
    background: #000;
    padding: 0 20px;
  }

  .dialog-title {
    color: #fff;
    font-size: 18px;
    font-weight: bold;
  }

  .dialog-close {
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    &:hover {
      opacity: 0.8;
    }
  }

  .dialog-content {
    background: #fff;
    height: 459px;
    padding: 32px 19px 0;
  }

  .dialog-scroll-area {
    max-height: 379px;
    overflow-y: auto;
  }

  .time-slot-row {
    flex-wrap: wrap;
  }

  .special-date-btns {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 72px;
    background: #fff;
  }
}
</style>
